// @flow
import React, {Component} from 'react';
import {FinalPage} from '../../../components/signUp';
import I18n from '../../../lib/i18n';
import theme from '../../../theme-config';

export default class Congrats extends Component<Props> {
  render() {
    let translatedTitle, translatedText;
    if (!this.props.isLoading) {
      if (this.props.error) {
        translatedText = this.props.error;
      } else {
        let title;
        let text;
        if (this.props.isRequestingPortability && this.props.eSimSelected) {
          title = 'SignUp.Congrats.thanks';
          text = 'SignUp.Congrats.contactingOperatorEsim';
        } else if (this.props.isRequestingPortability) {
          title = 'SignUp.Congrats.thanks';
          text = 'SignUp.Congrats.contactingOperator';
        } else if (this.props.eSimSelected) {
          title = 'SignUp.Congrats.congratsEsim';
          text = 'SignUp.Congrats.swapYourESim';
        } else {
          title = 'SignUp.Congrats.congrats';
          text = 'SignUp.Congrats.swapYourSim';
        }

        [translatedTitle, translatedText] = [I18n.t(title), I18n.t(text)];
      }
    }

    return (
      <FinalPage
        title={translatedTitle}
        text={translatedText}
        image={
          this.props.error
            ? theme.orderFailedImage
            : this.props.eSimSelected
              ? theme.welcomeEsimImage
              : theme.swapSimImage
        }
        imageStyle={{width: 202, height: 228, resizeMode: 'contain'}}
        isLoading={this.props.isLoading}
        hasError={!!this.props.error}
        eSimSelected={this.props.eSimSelected}
        installESim={this.props.installESim}
        onRetry={this.props.redirectAfterActivationFailed}
        goToDashboard={this.props.goToDashboard}
      />
    );
  }
}

type Props = {
  error?: string,
  isLoading: boolean,
  isRequestingPortability: boolean,
  eSimSelected: boolean,
  goToDashboard: Function,
  redirectAfterActivationFailed: Function,
  installESim: Function,
};
